package navigation.settings.datetime

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import core.dateformat.domain.DateFormatUseCase
import core.dateformat.ui.DateTimeEvent
import core.dateformat.ui.DateTimeState
import core.dateformat.ui.DateTimeViewModel

class DateTimeScreenModel(
    dateFormatUseCase: DateFormatUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<DateTimeState>(DateTimeState()) {

    private val viewModel =
        DateTimeViewModel(
            dateFormatUseCase = dateFormatUseCase,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: DateTimeEvent) = viewModel.onEvent(event)
}